<template>
  <el-form ref="form" :model="ruleForm" label-width="100px" :rules="rules">
    <el-form-item label="角色名称" prop="role_name">
      <el-input v-model="ruleForm.role_name" />
    </el-form-item>

    <el-form-item label="备注" prop="remark">
      <el-input
        type="textarea"
        :rows="3"
        placeholder="请输入内容"
        v-model="ruleForm.remark">
      </el-input>
    </el-form-item>

    <el-form-item style="text-align:left;">
      <el-button class="btn_dialog" @click="$emit('tableCloseDialog')">取消</el-button>
      <el-button class="btn_dialog cz" @click="onReset">重置</el-button>
      <el-button class="btn_dialog qd" @click="onOk">确定</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import Backend from '@/api/backend'

export default {
  data () {
    return {
      service: 'role',
      id_name: 'role_id',
      rules: {
        role_name: [
          { required: true, message: '请输入角色名称', trigger: ['blur', 'change'] }
        ]
      },
      ruleForm: {}
    }
  },

  props: ['rowData'],

  created () {
    this.getRow()
  },

  methods: {
    getRow () {
      for (const k in this.rowData) {
        this.$set(this.ruleForm, k, this.rowData[k])
      }
    },
    editRow () {
      Backend.editRow(
        this,
        {
          role_id: this.ruleForm.role_id,
          role_name: this.ruleForm.role_name,
          remark: this.ruleForm.remark
        },
        undefined
      )
    },
    onOk () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.editRow()
        }
      })
    },
    onReset () {
      this.$refs.form.resetFields()
    }
  }
}
</script>
